import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('authtoken');
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result.error && (result.error.status === 401)) {
    localStorage.removeItem('authtoken');
  }
  return result;
};
export const AdminPlanApi = createApi({
  reducerPath: 'AdminPlanApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAdminPlanList: builder.query({
      query: (param) => ({
        url: `/adminplan/list-plan/`,
        params:param,
      })
    }),
    postPlan: builder.mutation({
      query: (data) => ({
        url: `/adminplan/plan-create/`,
        method: "POST",
        body: data,
      }),
      transformResponse: (response, meta) => ({
        data: response,
        status: meta?.response?.status,
      }),
    }),
    deletePlan: builder.mutation({
      query: (id) => {
        return {
          url: `/adminplan/delete-plan/${id}/`,
          method: "DELETE",
        };
      },
    }),
    updatePlan: builder.mutation({
      query: ({ id, data }) => {
        console.log("Sending updated plan:", data);  // Debugging log
        return {
          url: `/adminplan/edit-plan/${id}/`,
          method: "PUT",
          body: data,
          headers: {
            "Content-Type": "application/json",  // Ensure JSON content type
          },
        };
      },
      transformResponse: (response, meta) => ({
        data: response,
        status: meta?.response?.status,
      }),
    }),

     createAdminPlan: builder.mutation({
      query: (data) => ({
        url: `/adminplan/admin-plans-create/`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      }),
      transformResponse: (response, meta) => ({
        data: response,
        status: meta?.response?.status,
      }),
    }),



    
  }),
})

export const { useGetAdminPlanListQuery, usePostPlanMutation, useDeletePlanMutation, useUpdatePlanMutation,useCreateAdminPlanMutation } = AdminPlanApi